import { withStyles } from '@material-ui/core';

const styles = () => ({
  '@global': {
    /**
     * Disable the focus outline, which is default on some browsers like
     * chrome when focusing elements
     */
    '*:focus': {
      outline: 0,
    },
    a: {
      textDecoration: 'none',
      color: 'inherit',
    },
    div: {
      '& .MuiPickersDateRangeDay-rangeIntervalDayHighlightStart': {
        '& .MuiPickersDay-root.Mui-selected': {
          backgroundColor: '#030C21',
          borderTopLeftRadius: 100,
          borderTopRightRadius: 8,
          borderBottomRightRadius: 8,
          borderBottomLeftRadius: 100,
        },
      },
      '& .MuiPickersDateRangeDay-rangeIntervalDayHighlight': {
        backgroundColor: '#FFFFFF',
        '& .MuiPickersDateRangeDay-rangeIntervalPreview': {
          backgroundColor: '#FAFAFA',
          color: '#030C21',
        },
      },
      '& .MuiPickersDateRangeDay-rangeIntervalDayHighlightEnd': {
        '& .MuiPickersDay-root.Mui-selected': {
          backgroundColor: '#030C21',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 100,
          borderBottomRightRadius: 100,
          borderBottomLeftRadius: 8,
        },
      },
    },
  },
});

function globalStyles() {
  return null;
}

export default withStyles(styles, { withTheme: true })(globalStyles);
